import ROOTURL from "../ROOTURL"
import { BUSINESSID } from "../ROOTURL"
import axios from "axios"

//Products APIs
export const getAllProducts = (businessID) =>
  axios.get(`${ROOTURL}/productInfoByBusiness/${businessID}`)

export const getProductById = (productID) =>
  axios.get(`${ROOTURL}/products/${productID}`)

//Product Category APIs
export const productCategories = () =>
  axios.get(
    `${ROOTURL}/businesses/${BUSINESSID}/productcategories?_where=(isDeleted,eq,0)`
  )
